import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import store from '@/uteis/store'

Vue.use(VueRouter)

const router = new VueRouter({ routes })

router.beforeEach((to, from, next) => {
  var sessao = store.getters.getDadosSessao
  if (to.name !== 'home' && !sessao) {
    next({ name: 'home' })
    return
  }

  next()
})

export default router
